import { useState, useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const useRealTimeNotifications = () => {
    const [isConnected, setIsConnected] = useState(false);
    const eventSourceRef = useRef(null);
    const queryClient = useQueryClient();

    useEffect(() => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (!token) return;

        const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
        const cleanToken = token.replace('Bearer ', '');
        const url = `${baseURL}/notifications/stream?token=${cleanToken}`;

        eventSourceRef.current = new EventSource(url);

        eventSourceRef.current.onopen = () => {
            setIsConnected(true);
            console.log('🔔 Real-time notifications connected');
        };

        eventSourceRef.current.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                
                if (data.type === 'new_notifications') {
                    // Invalidate and refetch notifications
                    queryClient.invalidateQueries(['notifications']);
                    
                    // Show browser notification if permission granted
                    if (Notification.permission === 'granted' && data.notifications.length > 0) {
                        const notification = data.notifications[0];
                        new Notification('Go Home Express', {
                            body: notification.message,
                            icon: '/favicon.ico'
                        });
                    }
                }
            } catch (error) {
                console.error('Error parsing notification data:', error);
            }
        };

        eventSourceRef.current.onerror = () => {
            setIsConnected(false);
        };

        // Request notification permission
        if (Notification.permission === 'default') {
            Notification.requestPermission();
        }

        return () => {
            if (eventSourceRef.current) {
                eventSourceRef.current.close();
                setIsConnected(false);
            }
        };
    }, [queryClient]);

    return { isConnected };
};